const SiteLink = ({msg}:any) =>{

  const siteLinkSubTitle01List = [
    {siteNm :"국토교통부", url :"http://www.molit.go.kr"},
    {siteNm :"고용노동부", url :"http://laborstat.moel.go.kr"},
    {siteNm :"과학기술정보통신부", url :"http://itstat.go.kr"},
    {siteNm :"농림축산식품부", url :"http://www.mafra.go.kr"},
    {siteNm :"출입국,외국인 정책본부", url :"http://www.immigration.go.kr"},
    {siteNm :"산업통상자원부", url :"http://www.motie.go.kr"},
    {siteNm :"문화체육관광부", url :"https://stat.mcst.go.kr"},
    {siteNm :"기획재정부", url :"http://www.moef.go.kr"},
    {siteNm :"행정안전부", url :"http://www.mois.go.kr"},
    {siteNm :"중소벤처기업부", url :"http://www.mss.go.kr"},
    {siteNm :"해양수산부", url :"http://www.mof.go.kr"},
    {siteNm :"관세청", url :"http://www.customs.go.kr"},
    {siteNm :"공정거래위원회", url :"http://www.ftc.go.kr"},
    {siteNm :"국세청", url :"http://stats.nts.go.kr"},
    {siteNm :"산림청", url :"http://www.forest.go.kr"},
    {siteNm :"조달청", url :"http://www.pps.go.kr"},
    {siteNm :"한국관광공사", url :"http://www.knto.or.kr"},
    {siteNm :"통계청(KOSIS)", url :"http://www.kosis.kr"},
    {siteNm :"한국전력공사", url :"http://www.kepco.co.kr"},
    {siteNm :"에너지경제연구원", url :"http://www.kesis.net"},
    {siteNm :"한국부동산원", url :"http://www.r-one.co.kr"},
    {siteNm :"한국고용정보원", url :"http://www.keis.or.kr"},
    {siteNm :"한국생산성본부", url :"http://www.kpc.or.kr"},
    {siteNm :"한국석유공사", url :"http://www.petronet.co.kr"}
  ]
  
  const siteLinkSubTitle02List = [
    {siteNm :"금융감독원", url :"http://www.fss.or.kr"},
    {siteNm :"중소기업은행", url :"http://research.ibk.co.kr"},
    {siteNm :"보험개발원", url :"http://www.kidi.or.kr/"},
    {siteNm :"수협중앙회", url :"http://www.suhyup.co.kr"},
    {siteNm :"한국예탁결제원", url :"http://www.ksd.or.kr"},
    {siteNm :"한국주택금융공사", url :"https://www.hf.go.kr"},
    {siteNm :"한국거래소", url :"http://www.krx.co.kr"},
    {siteNm :"한국무역협회", url :"http://www.kita.net"},
    {siteNm :"중소기업중앙회", url :"http://www.kbiz.or.kr"},
    {siteNm :"대한건설협회", url :"http://www.cak.or.kr"},
    {siteNm :"한국철강협회", url :"http://www.kosa.or.kr"},
  ]

  const siteLinkSubTitle03List = [
    {siteNm :"경제협력개발기구(OECD)", url :"http://www.oecd.org/statistics/"},
    {siteNm :"국제결제은행(BIS)", url :"https://www.bis.org/"},
    {siteNm :"국제노동기구(ILO)", url :"http://www.ilo.org/global/lang--en/index.htm"},
    {siteNm :"국제연합(UN)", url :"http://unstats.un.org/unsd/"},
    {siteNm :"국제통화기금(IMF)", url :"https://www.imf.org/en/Data"},
    {siteNm :"세계보건기구(WHO)", url :"https://www.who.int/"},
    {siteNm :"세계은행(WORLD BANK)", url :"http://www.worldbank.org/"},
    {siteNm :"아시아개발은행(ADB)", url :"http://www.adb.org"},
    {siteNm :"아시아태평양경제사회위원회(ESCAP)", url :"http://www.unescap.org/stat/"},
    {siteNm :"유엔식량농업기구(FAO)", url :"http://www.fao.org/home/en/"}
  ]

  const siteLinkSubTitle04List = [
    {siteNm : "대만", url :"http://www.cbc.gov.tw"},
    {siteNm : "독일", url :"https://www.bundesbank.de/en"},
    {siteNm : "미국", url :"http://www.federalreserve.gov/releases/"},
    {siteNm : "싱가포르", url :"http://www.mas.gov.sg"},
    {siteNm : "영국", url :"https://www.bankofengland.co.uk/"},
    {siteNm : "유럽중앙은행", url :"https://www.ecb.europa.eu/"},
    {siteNm : "일본", url :"http://www.boj.or.jp/en/statistics/index.htm/"},
    {siteNm : "중국", url :"http://www.pbc.gov.cn"},
    {siteNm : "캐나다", url :"http://www.bank-banque-canada.ca/en/rates.htm"},
    {siteNm : "프랑스", url :"https://www.banque-france.fr/en"},
    {siteNm : "홍콩", url :"https://www.hkma.gov.hk/eng"}
  ]
  
  const siteLinkSubTitle05List = [
    {siteNm :"뉴질랜드 : Statistics New Zealand", url :"http://www.stats.govt.nz/"},
    {siteNm :"대만 : National Statistics", url :"http://eng.stat.gov.tw/mp.asp?mp=5"},
    {siteNm :"덴마크 : Statistics Denmark", url :"http://dst.dk/en"},
    {siteNm :"독일 : Federal Statistical Office of Germany", url :"https://www.destatis.de/EN/Home/_node.html"},
    {siteNm :"러시아 : Federal State Statistics Service(FSSS)", url :"https://eng.gks.ru/"},
    {siteNm :"말레이시아 : Department of Statistics", url :"http://www.dosm.gov.my/v1/index.php"},
    {siteNm :"미국 : Federal Committee on STATISTICAL METHODOLOGY(FCSM)", url :"https://nces.ed.gov/FCSM/index.asp"},
    {siteNm :"미국 : Bureau of Labor Statistics", url :"http://www.bls.gov/home.htm"},
    {siteNm :"벨기에 : Statistics Belgium", url :"http://statbel.fgov.be/"},
    {siteNm :"스웨덴 : Statistics Sweden", url :"http://www.scb.se/en_/"},
    {siteNm :"스위스 : Swiss Statistics", url :"https://www.bfs.admin.ch/bfs/en/home.html"},
    {siteNm :"싱가포르 : Statistics Singapore", url :"http://www.singstat.gov.sg/"},
    {siteNm :"영국 : UK National Statistics", url :"http://www.statistics.gov.uk/"},
    {siteNm :"오스트리아 : Statistics Austria", url :"http://www.statistik.at/index_englisch.shtml"},
    {siteNm :"유럽연합 : Statistical Office of the European Union", url :"http://ec.europa.eu/eurostat"},
    {siteNm :"이탈리아 : National Institute of Statistics", url :"http://www.istat.it/en"},
    {siteNm :"일본 : Statistics Bureau", url :"http://www.stat.go.jp/english/index.htm"},
    {siteNm :"중국 : National Bureau of Statistics of China", url :"http://www.stats.gov.cn/english/"},
    {siteNm :"캐나다 : Statistics Canada", url :"http://www.statcan.gc.ca/start-debut-eng.html"},
    {siteNm :"태국 : National Statistical Office of Thailand", url :"http://www.nso.go.th/sites/2014en"},
    {siteNm :"호주 : Australian Bureau of Statistics", url :"http://www.abs.gov.au"},
    {siteNm :"프랑스 : National Institute for Statistics and Economic Studies", url :"http://www.insee.fr/en/home/home_page.asp"},
    {siteNm :"홍콩 : Census and Statistics Department", url :"http://www.censtatd.gov.hk/en/"}
  ]

  return (
    <div className="wrap-body-center overflow-none">
      <div className="container container-sh">
        <div className="container-top center">
          <div className="top-box">
            <div className="top-box-center top-box-center-site-link">
              <h2><strong>{msg['siteLinkTitle']}</strong></h2>
            </div>
          </div>
        </div>
        <div className="site-link-page">
          <div className="link-box clearfix">
            <h3 className="h3-01 clearfix"><strong dangerouslySetInnerHTML={{__html:msg['siteLinkSubTitle01']}}></strong></h3>
              <ul className="col-4">
                {
                  siteLinkSubTitle01List.map((list01:any, list01Index:number) => (
                    <li key={list01Index}>
                      <a onClick={() => window.open(list01['url'])}>{list01['siteNm']}</a>
                    </li>
                  ))
                }                             
            </ul>
          </div>
            <div className="link-box clearfix">
                    <h3 className="h3-02 clearfix"><strong dangerouslySetInnerHTML={{__html:msg['siteLinkSubTitle02']}}></strong></h3>
                    <ul className="col-4">
                      {
                          siteLinkSubTitle02List.map((list02:any, list02Index:number) => (
                            <li key={list02Index}>
                              <a onClick={() => window.open(list02['url'])}>{list02['siteNm']}</a>
                            </li>
                          ))
                      }         
                    </ul>
                </div>
            <div className="link-box clearfix">
                <h3 className="h3-03 clearfix"><strong dangerouslySetInnerHTML={{__html:msg['siteLinkSubTitle03']}}></strong></h3>
                <ul className="col-4">
                    {
                          siteLinkSubTitle03List.map((list03:any, list03Index:number) => (
                            <li key={list03Index}>
                              <a onClick={() => window.open(list03['url'])}>{list03['siteNm']}</a>
                            </li>
                          ))
                    }         
                </ul>
                </div>
            <div className="link-box clearfix">
                    <h3 className="h3-04 clearfix"><strong dangerouslySetInnerHTML={{__html:msg['siteLinkSubTitle04']}}></strong></h3>
                    <ul className="col-4">
                      {
                          siteLinkSubTitle04List.map((list04:any, list04Index:number) => (
                            <li key={list04Index}>
                              <a onClick={() => window.open(list04['url'])}>{list04['siteNm']}</a>
                            </li>
                          ))
                      }
                    </ul>
                </div>
            <div className="link-box clearfix">
                    <h3 className="h3-05 clearfix"><strong dangerouslySetInnerHTML={{__html:msg['siteLinkSubTitle05']}}></strong></h3>
                    <ul className="col-2 agency">
                      {
                          siteLinkSubTitle05List.map((list05:any, list05Index:number) => (
                            <li key={list05Index}>
                              <a onClick={() => window.open(list05['url'])}>{list05['siteNm']}</a>
                            </li>
                          ))
                      }
                    </ul>
                </div>
            </div>
        </div>
    </div>
  );
}
export default SiteLink;